/*!

=========================================================
* BLK Design System React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/blk-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/blk-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

export default function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col md="4">
            <div className="footer-brand">Hana</div>
            <p>Consultorios Odontológicos</p>
          </Col>
          <Col md="4">
            <h5>Contacto</h5>
            <p>Email: info@hana.com.ar</p>
            <p>Tel: +54 9 2996 31-6836</p>
            <p>Dirección: Av. Plottier 346, Plottier (Neuquén)</p>
          </Col>
          <Col md="4">
            <h5>Redes Sociales</h5>
            <div className="btn-wrapper profile">
              <Button
                className="btn-icon btn-neutral btn-round btn-simple"
                color="default"
                href="https://www.instagram.com/hana.odontologia/"
                id="tooltip-instagram"
                target="_blank"
              >
                <i className="fab fa-instagram" />
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip-instagram">
                Instagram
              </UncontrolledTooltip>
              <Button
                className="btn-icon btn-neutral btn-round btn-simple"
                color="default"
                href="https://wa.me/5492996316836"
                id="tooltip-whatsapp"
                target="_blank"
              >
                <i className="fab fa-whatsapp" />
              </Button>
              <UncontrolledTooltip delay={0} target="tooltip-whatsapp">
                WhatsApp
              </UncontrolledTooltip>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
